import { createContext, useContext, useReducer } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { PublicAmendmentDetailState, PublicAmendmentDetailReducer, ACTION_TYPES } from './public-amendment-detail-reducer';
export { ACTION_TYPES };

const PublicAmendmentDetailContext = createContext<PublicAmendmentDetailState | undefined>(undefined);
const PublicAmendmentDetailDispatchContext = createContext({} as any);

export const PublicAmendmentDetailProvider = ({ children }: { children: React.ReactNode }) => {
    const { amendmentId } = useParams();
    const location = useLocation();
    const navigationState = location.state as { parlamentarName?: string; politicalPartyAbbreviation?: string } | null;
    const initialState: PublicAmendmentDetailState = {
        amendmentId: amendmentId!,
        parlamentarName: navigationState?.parlamentarName,
        politicalPartyAbbreviation: navigationState?.politicalPartyAbbreviation,
        tabIndex: 0,
        commitments: [],
        transfers: [],
        accountReports: [],
        accountReportAttachments: [],
        attachments: [],
    };
    const [state, dispatch] = useReducer(PublicAmendmentDetailReducer, initialState);
    return (
        <PublicAmendmentDetailContext.Provider value={state}>
            <PublicAmendmentDetailDispatchContext.Provider value={dispatch}>
                {children}
            </PublicAmendmentDetailDispatchContext.Provider>
        </PublicAmendmentDetailContext.Provider>
    );
};

export const usePublicAmendmentDetailState = () => {
    const context = useContext(PublicAmendmentDetailContext);
    if (!context) throw new Error('usePublicAmendmentDetailState must be used within PublicAmendmentDetailProvider');
    return context;
};

export const usePublicAmendmentDetailDispatch = () => {
    const context = useContext(PublicAmendmentDetailDispatchContext);
    if (!context) throw new Error('usePublicAmendmentDetailDispatch must be used within PublicAmendmentDetailProvider');
    return context;
};
